module.exports = __webpack_public_path__ + "static/lahli_spinach_rustica_morning_protein_bites_BOP_560x667-601a8b36c24b63af6661f7a47f6de1a9.png";